module.exports = __webpack_public_path__ + "static/car-2-8215b199b4046eff3b1c2de1fd459619.png";